import { render, staticRenderFns } from "./lp-opportunities-for-investors-ii.vue?vue&type=template&id=ff4d387c&scoped=true"
import script from "./lp-opportunities-for-investors-ii.vue?vue&type=script&lang=js"
export * from "./lp-opportunities-for-investors-ii.vue?vue&type=script&lang=js"
import style0 from "./lp-opportunities-for-investors-ii.vue?vue&type=style&index=0&id=ff4d387c&prod&scoped=true&lang=css"
import style1 from "./lp-opportunities-for-investors-ii.vue?vue&type=style&index=1&id=ff4d387c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4d387c",
  null
  
)

export default component.exports